import { useState, ChangeEvent } from 'react'

import TextareaAutosize from 'react-textarea-autosize'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'

import { Props } from './types'

import InputGroup from 'common/components/form/inputGroup'
import Avatar from 'common/components/avatar'
import EmojiPicker from 'common/components/emojiPicker'
import IconButton from 'common/components/iconButton'
import { useLeadContext } from 'modules/lead/context'

import './messageInput.scss'

const MessageInput = ({
  addEmoji, sendMessage, textInput, maxRows, onChange, onKeyPress
}: Props) => {
  const { t } = useTranslation()
  const { lead: { name, color, photo } } = useLeadContext()

  const [boxUp, setBoxUp] = useState(false)

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const height = event.target.clientHeight

    setBoxUp(height > 27)
    onChange(event)
  }

  const append = (
    <>
      <EmojiPicker onSelect={addEmoji}/>
      <IconButton
        data-test="button-send-message"
        onClick={sendMessage}
        className={classnames({ 'icon-active': textInput.trim().length > 0 })}
        prefix="fas"
        iconName="paper-plane" />
    </>
  )

  return (
    <div className={classnames('message-input content', { 'input-change': boxUp })}>
      <Avatar alt={name} color={color} src={photo} />
      <InputGroup
        className="input-container"
        append={append}>
        <TextareaAutosize
          maxRows={maxRows}
          className="message-textarea hot-form-control"
          id="input-message"
          onChange={handleChange}
          onKeyPress={onKeyPress}
          placeholder={t('chat.placeholder')}
          value={textInput}
          data-test="chat-textarea"/>
      </InputGroup>
    </div>
  )
}

export default MessageInput
